const EMAIL_CONTENT_ATTR = "data-email-content";

export function wrapEmailHtml({ contentHtml }: { contentHtml: string }): string {
  const inner = contentHtml.trim();

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title></title>
</head>
<body style="margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">
  <div ${EMAIL_CONTENT_ATTR}="true" style="max-width:640px;margin:0 auto;">
    ${inner}
  </div>
</body>
</html>`;
}

export function extractEmailContentHtml(html: string): string {
  if (!html.trim()) {
    return "<p></p>";
  }

  if (typeof DOMParser === "undefined") {
    return html;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const marked = doc.querySelector(`[${EMAIL_CONTENT_ATTR}]`);
  if (marked) {
    return marked.innerHTML.trim() || "<p></p>";
  }

  const body = doc.body;
  if (body) {
    return body.innerHTML.trim() || "<p></p>";
  }

  return html;
}

export const DEFAULT_EMAIL_CAMPAIGN_HTML = wrapEmailHtml({
  contentHtml: "<p></p>",
});
